import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PDMySubscriptions from "./PDMySubscriptions";
import PDBuySubscription from "./PDBuySubscription";
import PDSubscriptionsGiftToMe from "./PDSubscriptionsGiftToMe";
import PDSubscriptionsIGifted from "./PDSubscriptionsIGifted";


export default function PDSubscription() {
    const authState =useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const user = authState?.user || {};
    const [tab, setTab] = useState("my");

    // COMMON THEME HELPERS
    const titleClass = `
        text-cyan-200
        text-sm
        lg:text-lg
        font-semibold
    `;

    const paragraphClass = `
        text-gray-100
        text-xs
        lg:text-sm
        leading-relaxed
    `;

    const buttonClass = `
        mt-2
        text-xs
        px-2
        py-1
        rounded-xl
        transition-all
        bg-blue-700
        hover: bg-blue-800
        text-white
    `;

    return (
        <div className="space-y-6 bg-gray-900 p-2 rounded-xl text-white">
            <div className="sticky top-0 bg-[#111827] border-b border-gray-700 p-3">
                <div className="text-cyan-400 font-bold">
                    PurpleDoor Subscription & Gifting
                </div>
                <div className="text-xs text-gray-400">
                    {user?.name}
                </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-5 gap-1 border-b border-gray-700 mt-2 p-1">
                <button
                    onClick={() => setTab("my")}
                    className={`text-xs lg:text-xs p-1 ${
                        tab === "my"
                        ? "bg-cyan-600"
                        : "bg-[#111827]"
                    }`}
                >
                    🎟️My Subscriptions
                </button>
                <button
                    onClick={() => setTab("buy")}
                    className={`text-xs lg:text-xs p-1 ${
                        tab === "buy"
                        ? "bg-cyan-600"
                        : "bg-[#111827]"
                    }`}
                >
                    💰Buy / Gift
                </button>
                <button
                    onClick={() => setTab("fuelstash")}
                    className={`text-xs lg:text-xs p-1 ${
                        tab === "fuelstash"
                        ? "bg-cyan-600"
                        : "bg-[#111827]"
                    }`}
                >
                   ⛽FuelStash
                </button>
                <button
                    onClick={() => setTab("gifttome")}
                    className={`text-xs lg:text-xs p-1 ${
                        tab === "gifttome"
                        ? "bg-cyan-600"
                        : "bg-[#111827]"
                    }`}
                >
                    🎁Gift to Me
                </button>
                <button
                    onClick={() => setTab("igifted")}
                    className={`text-xs lg:text-xs p-1 ${
                        tab === "igifted"
                        ? "bg-cyan-600"
                        : "bg-[#111827]"
                    }`}
                >
                    🦋I Gifted
                </button>
            </div>
            {
                tab === "my" && <PDMySubscriptions userId={user?._id}/>
            }
            {
                tab === "buy" && <PDBuySubscription user={user}/>
            }
            {
                tab === "gifttome" && <PDSubscriptionsGiftToMe userId={user?._id}/>
            }
            {
                tab === "igifted" && <PDSubscriptionsIGifted userId={user?._id}/>
            }
            {   
                tab === "fuelstash" && (
                <div className="space-y-6 text-center bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
                    <h2 className={titleClass}>
                        FuelStash
                    </h2>
                    <button onClick={() => navigate("/fuelstash")} className={buttonClass}>
                        🚀 Fuel Up Before Takeoff.
                    </button>
                    <div className="space-y-3 mt-3">
                        <p className={paragraphClass}>
                        ⚡Fuel Stash is your personal energy reserve inside Think5Whys for growth, rewards, progress, and
                        everyday ecosystem activities.
                        </p>
                        <p className={paragraphClass}>
                        🎯 Earn Fuel through learning, discipline,  consistency, achievements, participation, contributions, and positive actions.
                        </p>
                        <p className={paragraphClass}>
                        🚀 Use your Fuel for transformational ecosystem experiences, rewards, ecosystem access, services, activities, and future growth opportunities.
                        </p>
                        <p className={paragraphClass}>
                        📈 Track your Fuel history, streaks, rewards, boosts, and smart activity insights across your transformation journey.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}